var _defs, _path, _rect, _path2, _rect2, _path3, _rect3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28.48 37.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#000;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Mesa de trabajo 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.07,27.67v-6.6a.44.44,0,0,0-.5-.45,6.69,6.69,0,0,0-5.74,6.84,6.77,6.77,0,0,0,6.77,6.45,6.65,6.65,0,0,0,3.77-1.22.44.44,0,0,0,0-.67Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3.48,
    y: 3.68,
    width: 10,
    height: 2.14
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.53,27.67H14.92l4.4,4.41a.45.45,0,0,0,.62,0,6.65,6.65,0,0,0,2-3.92A.45.45,0,0,0,21.53,27.67Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3.48,
    y: 8.88,
    width: 10,
    height: 2.14
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.09,25.87a6.71,6.71,0,0,0-6.22-6.22.45.45,0,0,0-.46.46v6.23h6.23A.45.45,0,0,0,21.09,25.87Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3.48,
    y: 14.07,
    width: 22,
    height: 2.17
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18.39,11.87a1.79,1.79,0,0,1-1.78-1.78V0H1.78A1.77,1.77,0,0,0,0,1.78V36.2A1.78,1.78,0,0,0,1.78,38H26.7a1.78,1.78,0,0,0,1.78-1.78V11.87ZM3.48,3.68h10V5.82h-10Zm0,5.2h10V11h-10ZM17.37,32.69a6.65,6.65,0,0,1-3.77,1.22,6.77,6.77,0,0,1-6.77-6.45,6.69,6.69,0,0,1,5.74-6.84.44.44,0,0,1,.5.45v6.6L17.41,32A.44.44,0,0,1,17.37,32.69Zm2.57-.6a.45.45,0,0,1-.62,0l-4.4-4.41h6.61a.45.45,0,0,1,.45.5A6.65,6.65,0,0,1,19.94,32.09Zm-5.53-5.75V20.11a.45.45,0,0,1,.46-.46,6.71,6.71,0,0,1,6.22,6.22.45.45,0,0,1-.45.47Zm11.07-10.1h-22V14.07h22Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M28,7.79,20.7.52A1.78,1.78,0,0,0,19.44,0H19V9.49h9.49V9A1.73,1.73,0,0,0,28,7.79Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.40c0a1e9c19b8ea78f586d68c229e290.svg";
export { ForwardRef as ReactComponent };